/* eslint-disable */
import GraphQL from '../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UserReviewSitesQueryVariables = GraphQL.Exact<{
  legacyUserId: GraphQL.Scalars['ID']['input'];
}>;


export type UserReviewSitesQuery = { readonly __typename?: 'Query', readonly user: { readonly __typename?: 'User', readonly id: string, readonly legacyId: string, readonly reviewSites: ReadonlyArray<string> | null } | null };


export const UserReviewSitesDocument = gql`
    query UserReviewSites($legacyUserId: ID!) {
  user(legacyId: $legacyUserId) {
    id
    legacyId
    reviewSites
  }
}
    `;

/**
 * __useUserReviewSitesQuery__
 *
 * To run a query within a React component, call `useUserReviewSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserReviewSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserReviewSitesQuery({
 *   variables: {
 *      legacyUserId: // value for 'legacyUserId'
 *   },
 * });
 */
export function useUserReviewSitesQuery(baseOptions: Apollo.QueryHookOptions<UserReviewSitesQuery, UserReviewSitesQueryVariables> & ({ variables: UserReviewSitesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserReviewSitesQuery, UserReviewSitesQueryVariables>(UserReviewSitesDocument, options);
      }
export function useUserReviewSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserReviewSitesQuery, UserReviewSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserReviewSitesQuery, UserReviewSitesQueryVariables>(UserReviewSitesDocument, options);
        }
export function useUserReviewSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserReviewSitesQuery, UserReviewSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserReviewSitesQuery, UserReviewSitesQueryVariables>(UserReviewSitesDocument, options);
        }
export type UserReviewSitesQueryHookResult = ReturnType<typeof useUserReviewSitesQuery>;
export type UserReviewSitesLazyQueryHookResult = ReturnType<typeof useUserReviewSitesLazyQuery>;
export type UserReviewSitesSuspenseQueryHookResult = ReturnType<typeof useUserReviewSitesSuspenseQuery>;
export type UserReviewSitesQueryResult = Apollo.QueryResult<UserReviewSitesQuery, UserReviewSitesQueryVariables>;